var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClassitem(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "class_armor",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 51 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.12,7.12C38.99,9.45,25.5,9.02,25.5,9.02S12.01,9.45,7.88,7.12C7.51,6.91,7.03,7.09,6.94,7.51 C6.58,9,6.07,11.93,7.03,13.37c0.09,0.13,0.22,0.21,0.38,0.25c1.23,0.3,7.36,1.65,18.09,1.65c10.73,0,16.86-1.35,18.09-1.65 c0.15-0.04,0.29-0.12,0.38-0.25c0.96-1.44,0.45-4.37,0.1-5.86C43.97,7.09,43.49,6.91,43.12,7.12z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.27,28.34c0,0,0,2.34,2.27,2.34s2.27-2.34,2.27-2.34V15.73c-1.93-0.22-3.45-0.45-4.55-0.65V28.34z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3,34.8c0,0,0,2.34,2.27,2.34s2.27-2.34,2.27-2.34V16.24c-1.66-0.06-3.18-0.16-4.55-0.27V34.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.18,28.34c0,0,0,2.34,2.27,2.34s2.27-2.34,2.27-2.34V15.08c-1.09,0.2-2.61,0.44-4.55,0.65V28.34z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.15,34.8c0,0,0,2.34,2.27,2.34s2.27-2.34,2.27-2.34V15.97c-1.36,0.11-2.88,0.21-4.55,0.27V34.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.23,16.31v25.31c0,0,0,2.34,2.27,2.34s2.27-2.34,2.27-2.34V16.31c-0.74,0.01-1.49,0.02-2.27,0.02 C24.72,16.34,23.96,16.33,23.23,16.31z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassitem);
export default __webpack_public_path__ + "static/media/classitem.6b98395bba81251ac51b3c87e4c1213e.svg";
export { ForwardRef as ReactComponent };